// extracted by mini-css-extract-plugin
module.exports = {"chipHorizonSelectorRoot":"zBHgCKwZ"};